import { TLocation } from 'shared/map-search/types/location';

export const getRegionId = (location: TLocation): number => {
  if (location === 'moscow_mo') {
    return -1;
  }

  if (location === 'spb_lo') {
    return -2;
  }

  if (location.parentId) {
    return location.parentId;
  }

  return location.id;
};
